import { Toaster } from "sonner";
import Navbar from "../components/jetdog/Navbar";
import Hero from "../components/jetdog/Hero";
import MarqueeBar from "../components/jetdog/MarqueeBar";
import About from "../components/jetdog/About";
import Tokenomics from "../components/jetdog/Tokenomics";
import HowToBuy from "../components/jetdog/HowToBuy";
import Roadmap from "../components/jetdog/Roadmap";
import FAQ from "../components/jetdog/FAQ";
import Footer from "../components/jetdog/Footer";
import WaveDivider from "../components/jetdog/WaveDivider";
import LivePrice from "../components/jetdog/LivePrice";
import Leaderboard from "../components/jetdog/Leaderboard";

export default function HomePage() {
  return (
    <div data-testid="home-root">
      <Navbar />
      <Hero />
      <MarqueeBar variant="yellow" direction="left" />
      <About />
      <WaveDivider fill="#005C8A" />
      <Tokenomics />
      <LivePrice />
      <WaveDivider fill="#00E5FF" flip />
      <HowToBuy />
      <MarqueeBar variant="yellow" direction="right" />
      <Roadmap />
      <div className="bg-[var(--jd-bg)] pt-6">
        <Leaderboard />
      </div>
      <FAQ />
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}
